// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8jVLt","paper-container":"styles_paper-container__nWiXE","verifiedByBank":"styles_verifiedByBank__+v7DL"};